<template>
  <div id="TopUp">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>เติมเงินเข้าระบบ</h2>
          <b-card bg-variant="light" class="mb-3">
            <h4>รายละเอียดการเติมเงิน</h4>
            <b-row>
              <!-- <b-col sm="6" class="mb-2"> -->
              <b-col>
                <!-- <label for="bank_name" class="mb-1">จำนวนเงิน:</label>
                <b-form-input id="bank_name" autocomplete="off" class="mb-2" v-model="form.firstName" type="number" ></b-form-input> -->
                <b-form-group label="บัญชีที่โอนเงิน:" v-slot="{ ariaDescribedby }" class="mb-2">
                  <!-- <b-form-radio class="custom-radio-purple" v-model="form.bankAccountLicm"
                    :aria-describedby="ariaDescribedby" name="bank-radios"
                    value="027-8-24576-4">
                    ธนาคารกสิกรไทย 027-8-24576-4 นางสาวพีรญา แสงบุญเรือง
                  </b-form-radio> -->
                  <b-form-radio class="custom-radio-purple" v-model="form.bankAccountLicm"
                    :aria-describedby="ariaDescribedby" name="bank-radios"
                    value="165-235662-5">
                    ธนาคารไทยพาณิชย์ 165-235662-5 นส.บุษรินทร์ อ้นแขกสุวรรณ
                  </b-form-radio>
                </b-form-group>

                <label for="transferDate" class="mb-1">วันที่เติมเงิน:</label>
                <b-form-datepicker
                  id="transferDate"
                  reset-button
                  close-button
                  locale="th"
                  placeholder="เลือกวันที่เข้าโกดัง"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  class="mb-2"
                  v-model="form.transferDate"
                ></b-form-datepicker>

                <label for="transferTime" class="mb-1">เวลา (โดยประมาณ):</label>
                <b-form-timepicker id="transferTime"
                  v-model="form.transferTime" locale="th"
                  class="mb-2"
                  now-button
                  placeholder="เลือกเวลา"
                  label-now-button="เลือกเวลาปัจจุบัน"
                  label-close-button="ปิด"
                ></b-form-timepicker>

                <label for="form_amount" class="mb-1">จำนวนเงิน:</label>
                <b-input-group append="บาท" class="mb-2">
                  <b-form-input id="form_amount" autocomplete="off" v-model="form.amountText" type="number"></b-form-input>
                </b-input-group>
              <!-- </b-col>

              <b-col sm="6"> -->
                <div class="mb-1">หลักฐานการโอนเงิน:</div>
                <b-form-file v-model="fileimg" ref="file-input-img"
                  @input="uploadFile()" browse-text="เลือกไฟล์" accept="image/*"
                  drop-placeholder="แนบไฟล์สลิปการโอนเงิน" placeholder="แนบไฟล์สลิปการโอนเงิน"
                  class="mb-3"></b-form-file>

                <b-img thumbnail fluid width="350" center :src="form.pictureSlipTopUp" v-if="form.pictureSlipTopUp" alt="หลักฐานการโอนเงิน"></b-img>

                <label for="noteSlipTopUp" class="mb-1">รายละเอียดเพิ่มเติม:</label>
                <b-form-input id="noteSlipTopUp" autocomplete="off" class="mb-2" v-model="form.noteSlipTopUp" type="text"></b-form-input>
              </b-col>
            </b-row>
          </b-card>

          <hr>

          <div class="text-center mt-2" v-if="dataReady">
            <b-button variant="purple" size="lg" @click="onSubmit()" :disabled="form.pictureSlipTopUp === ''">
              <f-icon icon="receipt"></f-icon>
              แจ้งชำระเงินเติมเข้าระบบ
            </b-button>
          </div>

          <hr>

          <h2>ประวัติการเติมเงินย้อนหลัง 5 รายการ</h2>
          <b-overlay
            id="overlay-dataSlipReady"
            :show="!dataSlipReady"
            variant="light"
            :opacity="0.95"
            blur="4px"
            rounded="sm"
          >
            <template #overlay>
              <div class="text-center">
                <h4 id="cancel-label">กำลังเรียกดูข้อมูล</h4>
              </div>
            </template>

            <b-table striped bordered small responsive
              :items="topUpItems" :fields="topUpFields"
              show-empty empty-text="ไม่พบการชำระเงิน"
              class="table-mini">

              <template #cell(showDetails)="row">
                <b-button size="sm" @click="row.toggleDetails">
                  <f-icon icon="receipt"></f-icon> {{ row.detailsShowing ? 'ซ่อน' : 'แสดง' }}สลิป
                </b-button>
              </template>

              <template #cell(createTopUptime)="data">
                {{ data.value.date }} {{ data.value.time }}
              </template>

              <template #row-details="row">
                  <b-row class="my-2">
                    <b-col>
                      <b-img thumbnail fluid width="300" center
                        :src="row.item.pictureSlipTopUp" v-if="row.item.pictureSlipTopUp"
                        alt="หลักฐานการโอนเงิน"></b-img>
                    </b-col>
                  </b-row>
              </template>

            </b-table>
          </b-overlay>

        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "TopUp",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น

    this.getDateNow()
    this.getDataUser()
    await this.getDataTopUp()
  },
  data() {
    return {
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        bankAccountLicm: "165-235662-5",
        transferDate: "",
        transferTime: "",
        amount:  "",
        amountText:  "",
        pictureSlipTopUp: "",
        noteSlipTopUp: "",
        userName: "",
        userCode: "",
        CREATE_USER: "",
        status: "รอยืนยันการเติมเงิน",
      },
      fileimg: null,
      dataReady: false,
      dataSlipReady: false,
      topUpFields: [
        { key: 'createTopUptime', label: 'แจ้งเติมเงินเวลา' },
        { key: 'transferDate', label: 'วันที่เติมเงิน' },
        { key: 'transferTime', label: 'เวลาเติมเงิน' },
        { key: 'amount', label: 'จำนวนเงิน' },
        { key: 'noteSlipTopUp', label: 'รายละเอียดเพิ่มเติม' },
        { key: 'status', label: 'สถานะการเติมเงิน' },
        { key: 'showDetails', label: 'หลักฐานสลิป' }
      ],
      topUpItems: [],
    };
  },
  methods: {
    getDateNow () {
      let dateTime = this.getNowGlobal().split(' ')
      this.form.transferDate = dateTime[0]
      this.form.transferTime = dateTime[1]
    },
    formatDate (strDate) {
      if (strDate) {
        var dtDate = strDate.split(' ')[0]
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0]
        return strDateShort
      } else {
        return ''
      }
    },
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser

        this.form.CREATE_USER = this.userData.userName
        this.form.userName = this.userData.userName
        this.form.userCode = this.userData.userCode

        this.dataReady = true
      } else {
        this.$router.push('/Login')
      }
    },
    getDataTopUp () {
      this.dataSlipReady = false
      this.topUpItems = []
      let uc = ""
      if (this.userData.userCode) { uc = '&userCode=' + this.userData.userCode }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Slip_top_up/Slip_top_up_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          uc +
          '&top=5',
          {
            headers: this.getHeaderAPI('Slip_top_up_list', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataTopUp', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let topUpData = rs.data[i]

                topUpData.createTopUptime = this.formatDateTime(rs.data[i].CREATE_DATE)
                // topUpData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)

                this.topUpItems.push(topUpData)
              }

              console.log('getDataTopUp', this.topUpItems)
            }
          }

          this.dataSlipReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTopUp error:', error)
          this.dataSlipReady = true
          this.topUpItems = []
        });
    },
    getFileBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async uploadFile () {
      if (this.fileimg) {
        await this.getFileBase64(this.fileimg)
          .then(picBase64 => {
            // console.log('uploadFile Base64', picBase64)
            this.form.pictureSlipTopUp = picBase64
          })
      }
    },
    // onInvoiceSelected (invoice) {
    //   // let dataInvice = invoice[0]
    //   console.log("onInvoiceSelected", invoice)
    //   if (invoice.length > 0) {
    //     this.form.deliverDoc = invoice[0].deliverDoc
    //   } else {
    //     this.form.deliverDoc = ''
    //   }
    // },
    onSubmit () {
      console.log("onSubmit Data:", this.form)

      this.form.amount = this.form.amountText.split(',').join('')
      delete this.form.amountText

      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Slip_top_up/Slip_top_up_add",
          this.form,
          {
            headers: this.getHeaderAPI('Slip_top_up_add', this.form.userName)
          }
        )
        .then(async (response) => {
          console.log('onSubmit', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แจ้งการเติมเงินเรียบร้อย","success")
              .then((result) => {
                this.$router.push('/Route?target=TopUp&uriType=User')
              })
            this.dataReady = true
          } else {
            console.log('onSubmit Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแจ้งการเติมเงินได้ กรุณาติดต่อแอดมิน","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("Error Insert","ไม่สามารถแจ้งการเติมเงินได้ กรุณาติดต่อแอดมิน","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

.py-75{
  padding-top: .75rem !important;
  padding-bottom: .75rem !important;
}

.ex-card{
  border-style: dotted;
  border-width: 2px;
}

.ex-card > .card-body {
  padding: .75rem;
}

.dropdown-menu {
  min-width: 5rem !important;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/User/TopUp.vue